export default "__VITE_ASSET__Deo7f9Y$__"